export const GET_USER_APPROVAL = `
query GetAllUserApproval($input:TuserApprovalWhereInput,$skip:Float,$take:Float){
    getUserApproval(where:$input,take:$take,skip:$skip,orderBy:{createDate:DESC}){
        pageInfo{
            hasNextPage
            currentPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            tcustomer{
                id
                storeName
            }
            approvalId
            tapproval{
                name
            }
            statusApproval
            tstatusApproval{
                name
            }
            idConnect
            plantId
            createId
            modifyDate
            tcreateUser{
                fullName
            }
            createDate
            tmodifyUser{
                fullName
            }
            modifyDate
            tuserApprovalDetail{
                id
                email
                approvalYn
                canView
            }
        }
    }
}`;

export const GET_APPROVAL_TYPES = `
query GetApprovalComboBox($input:TapprovalWhereInput,$skip:Float,$take:Float){
    getApproval(where:$input,skip:$skip,take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            name
        }
    }
}`;

export const GET_APPROVAL_STATUS = `
    query GetAllUserApproval($input:TcodeWhereInput,$skip:Float,$take:Float){
        getCode(where:$input,take:$take,skip:$skip){
            pageInfo{
                hasNextPage
                currentPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                name
            }
        }
    }
`;

export const GET_USER_APPROVAL_FOR_PURCHASE = `
    query GetAllUserApproval($input:TuserApprovalWhereInput,$skip:Float,$take:Float){
        getUserApproval(where:$input,skip:$skip,take:$take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                useYn
                plantId
                approvalId
                tapproval{
                    id
                    name
                    tcreateUser{
                        fullName
                        jobTitle
                    }
                    createDate
                }
                statusApproval
                tstatusApproval{
                    id
                    name
                }
                createDate
                tcreateUser{
                    fullName
                    jobTitle
                }
                modifyDate
                tmodifyUser{
                    fullName
                }
            }
        }
    }
`;

export const GET_PURCHASE_APPROVAL = `
query  GetPurchaseUserApproval($input: FOrderUserApprovalDetailPurchaseInput){
    getPurchaseUserApproval(where: $input){
        id,
        currentMartketGoldPrice,
        marketGoldPrice,
        totalGoldPrice,
        totalQuantity,
        totalQ10Sale,
        totalQ10Buy,
        totalFinalPrice,
        purchaseType,
        policyType,
        note,
        q10LimeOut,
        tcustomer{
            id,
            name,
            sapCustomerId,
            trank { 
                name
            },   
        }
        tpurchaseOrderQ10 {
            id 
            orderId
        }
    }
}`;

export const GET_USER_APPROVAL_FOR_ORDER = `
query GetAllUserApproval($input:TuserApprovalWhereInput,$skip:Float,$take:Float){
    getUserApproval(where:$input,skip:$skip,take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            useYn
            plantId
            approvalId
            tuserApprovalDetail{
                id
                email
                approvalYn
            }
            tapproval{
                id
                name
                tcreateUser{
                    fullName
                    jobTitle
                }
                createDate
            }
            statusApproval
            tstatusApproval{
                id
                name
            }
            createDate
            tcreateUser{
                fullName
                jobTitle
            }
            modifyDate
            tmodifyUser{
                fullName
            }
        }
    }
}`;

export const GET_ORDER_APPROVAL = `
query GetOrderDataUserApproval($input:FOrderUserApprovalDetailInput!){
    getOrderUserApproval(where:$input){
        id
        totalQ10
        totalQuantity
        discount
        marketGoldPrice
        dealPrice
        totalGoldPrice
        totalProcessPrice
        totalProductPrice
        finalPrice 
        note
        orderTypeId
        tcustomer{
            id
            sapCustomerId
            storeName
            trank{
                name
            }
        }
    }
}`;

export const GET_USER_CUSTOMER_APPROVAL = `
query GetAllUserApprovalDetail($input:TuserApprovalDetailWhereInput,$skip:Float,$take:Float){
    getUserApprovalDetail(where:$input,skip:$skip,take:$take,orderBy:{indexNum:ASC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            userApprovalId
            tuserApproval{
                id
                approvalId
                statusApproval
                tstatusApproval{
                    id
                    name
                }
            }
            email
            indexNum
            approvalYn
            createDate
            tcreateUser{
                fullName
                jobTitle
            }
            modifyDate
            tmodifyUser{
                fullName
            }
        }
    }
}`;

export const GET_CUSTOMER_APPROVAL = `
query GetNewCustomerUserApproval($input: TcustomerWhereInput, $skip: Float, $take: Float) {
  getCustomer(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
        id
        storeName
        name
        mainCustomerId
        mainCustomer{
            storeName
            sapCustomerId
        }
        sapCustomerId
        typeSap
        titleSap
        storeName
        taxId
        cccd
        email
        phone
        gender
        dayofbirth
        address
        latitude
        longitude
        status
        shortName
        note
        urlImage1
        urlImage2
        urlImage3
        urlImage4
        urlImage5
        createDate
        tcity{
            name
        }
        tdistrict{
            name
        }
        tward{
            name
        }
        trank{
            name
        }
        tcustomerLineProduct{
            id
            lineProductId
            lineProducts{
                name
            }
            note
        }
    }
  }
}`;

export const UPDATE_APPROVAL_STATUS = `
mutation UpdateApprovalStatus($input:TuserApprovalDetailInput!){
    updateUserApprovalDetail(input:$input){
        id
        approvalYn
    }
}`;
